import {computed} from "mobx";
import {PositionViewModel} from "../../position/position.view-model";
import {EventViewModel} from "../../../common/events/models/event-view-model";
import {LineupsMemberDomainModel} from "./lineups-member-domain-model";
import {FormationPositionViewModel} from "../../formation/formation-position.view-model";
import {LineupsMemberInjuryViewModel} from "./injury/lineups-member-injury-view-model";
import {LineupsMemberSuspensionViewModel} from "./suspension/lineups-member-suspension-view-model";
import {LineupsMemberYardFormationViewModel} from "./yard-formation/lineups-member-yard-formation-view-model";
import {EventDomainModel} from "../../../common/events/models/event-domain-model";
import {LINEUPS} from "../../../../widgets/lineups-widget/lineups-widget.consts";
import {LineupsMemberSeasonStatsDomainModel} from "./season-stats/lineups-member.season-stats.domain-model";
import {PREMIUM_STATS, SOCCER_EVENT_TYPES} from "../../../../core/app/consts";
import {LineupsMemberStatsDomainModel} from "./stats/lineups-member.stats.domain-model";
import {LineupsMemberStatsViewModel} from "./stats/lineups-member.stats.view-model";
import {MemberViewModel} from "../../member/member-view-model";

export class LineupsMemberViewModel extends MemberViewModel {
  domainModel: LineupsMemberDomainModel;

  @computed get events() {
    const events: Array<EventViewModel> = this.domainModel.events?.map((event: EventDomainModel) => !event.hideFromLineup && new EventViewModel(event)).filter(x => x);

    return events;
  }

  @computed get hasEvents(): Boolean {
    return this.events?.length > 0;
  }

  @computed get substitutionEvent(): EventViewModel {
    const substitutionEvent = this.events?.find((event: EventViewModel) => event.eventType.id === SOCCER_EVENT_TYPES.substitution);

    return substitutionEvent;
  }

  @computed get subsPlayerJerseyNumber(): String {
    const subsPlayerJerseyNumber: String = this.substitutionEvent?.extraPlayers[0].jerseyNumber;

    return subsPlayerJerseyNumber;
  }

  get substitutionOrder(): Number {
    const events: Array<EventViewModel> = this.events.filter((event: EventViewModel) => event.eventType.id === LINEUPS.EVENT_TYPES.substitution);

    if (events.length) {
      return events[events.length - 1].order
    }

    return -1;
  }

  @computed get position(): PositionViewModel {
    const position = this.domainModel.position && new PositionViewModel(this.domainModel.position);

    return position;
  }

  @computed get formation(): FormationPositionViewModel {
    const formation = this.domainModel.formation && new FormationPositionViewModel(this.domainModel.formation);

    return formation;
  }

  @computed get yardFormation(): LineupsMemberYardFormationViewModel {
    const yardFormation = this.domainModel.yardFormation && new LineupsMemberYardFormationViewModel(this.domainModel.yardFormation);

    return yardFormation;
  }

  @computed get injury(): LineupsMemberInjuryViewModel {
    const injury = this.domainModel.injury && new LineupsMemberInjuryViewModel(this.domainModel.injury);

    return injury;
  }

  @computed get suspension(): LineupsMemberSuspensionViewModel {
    const suspension = this.domainModel.suspension && new LineupsMemberSuspensionViewModel(this.domainModel.suspension);

    return suspension;
  }

  @computed get seasonStats(): String {
    let seasonStats = '';

    this.domainModel.seasonStats?.forEach((stat: LineupsMemberSeasonStatsDomainModel) => {
      let text: String = stat.text;

      if (stat.isSignificant) {
        text = text.addColorToSubString(stat.color)
      }

      seasonStats += ` ${text}`;
    });

    return seasonStats;
  }

  @computed get status(): Number {
    return this.domainModel.status;
  }

  @computed get statusText(): String {
    return this.domainModel.statusText;
  }

  @computed get isRankingEmptyState(): Boolean {
    const isRankingEmptyState: Boolean = this.domainModel.ranking <= -1

    return isRankingEmptyState;
  }

  @computed get ranking(): String {
    const ranking: String = this.isRankingEmptyState ? '-' : this.domainModel.ranking?.toFixed(1)

    return ranking;
  }

  @computed get shouldRenderPlayerCardRanking(): Boolean {
    const shouldRenderPlayerCardRanking: Boolean = !this.injury && !!this.ranking;

    return shouldRenderPlayerCardRanking;
  }

  @computed get hasHighestRanking(): Boolean {
    return this.domainModel.hasHighestRanking;
  }

  @computed get didNotPlayed(): Number {
    return this.domainModel.didNotPlayed;
  }

  @computed get didNotPlayedReason(): String {
    return this.domainModel.didNotPlayedReason;
  }

  @computed get hasStats(): Boolean {
    return this.domainModel.hasStats;
  }

  @computed get stats(): Array<LineupsMemberStatsViewModel> {
    const stats: Array<LineupsMemberStatsViewModel> = this.domainModel.stats?.map((stat: LineupsMemberStatsDomainModel) => new LineupsMemberStatsViewModel(stat));

    return stats?.filter((stat: LineupsMemberStatsDomainModel) => this.allowPremiumData !== false || !PREMIUM_STATS.SPORT.includes(stat.type));
  }

  @computed get heatMap(): String {
    return this.domainModel.heatMap;
  }

  @computed get fouledOut(): Boolean {
    return this.domainModel.fouledOut;
  }

  @computed get gameId(): Boolean {
    return this.domainModel.gameId;
  }

  @computed get nationalId(): Boolean {
    return this.domainModel.nationalId;
  }

  @computed get isDoubtful(): Boolean {
    return this.domainModel.isDoubtful;
  }
}
